import PropTypes from 'prop-types';

import toLower from '../../../OC/PageBuilder/utilities/toLower';
import IconMapMarker from '../../icons/icon-map-marker';
import { formatBuyType } from '../format-buy-type';
import { ActionLink } from '../result-block-styled-components';

const Directions = ({ label, address, buyType, name, supplierId }) => (
  <ActionLink
    href={`http://maps.google.com/?q=${address}`}
    tabIndex={0}
    data-track="view-directions"
    data-track-buy-type={formatBuyType(buyType)}
    data-track-supplier-id={supplierId}
    data-track-supplier-name={toLower(name)}
  >
    <IconMapMarker width="13" fill="currentColor" className="icon" />
    {label}
  </ActionLink>
);

Directions.propTypes = {
  label: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  buyType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Directions.defaultProps = {
  supplierId: undefined,
};

export default Directions;
